import httpRequest from '../../common/lib/http-request';

// *******************
// ASSOCIATE SERVICES
// *******************

function checkProfessionalName(associateId, professionalName) {
    return httpRequest({
        url: '/Associate/professional/check',
        method: 'POST',
        data: {
            associateId: associateId,
            professionalName: professionalName
        }
    }, false, process.env.REACT_APP_CORE_NEW_API_URL);
}

function checkAssociateExists(request) {
    return httpRequest({
        url: '/Associate/check/',
        method: 'POST',
        data: request
    }, false, process.env.REACT_APP_CORE_NEW_API_URL);
}

function getScapContentResponseStatus(associateId) {
    return httpRequest({
        url: '/Associate/scap/status/consent/' + associateId,
        method: 'POST'
    }, false, process.env.REACT_APP_CORE_NEW_API_URL);
}

function updateScapConsent(request) {
    return httpRequest({
        url: '/Associate/scap/consent',
        method: 'POST',
        data: request
    }, false, process.env.REACT_APP_CORE_NEW_API_URL);
}

const AssociateService = { checkProfessionalName, checkAssociateExists, getScapContentResponseStatus, updateScapConsent }

export default AssociateService;